import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router";
import axios from "axios";

import stringify from "json-stable-stringify";

import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import uuidV4 from "uuid/v4";
import Notification from "../../components/Notification.js";

import {
    setTag,
    changeRule,
    setGlobalKeyState,
    deleteRow,
    setGlobalTypeState,
    setSidebarState,
    addRowPlaceholder,
    removeElement,
    addElement,
    setSelectedTab,
    addRow,
    moveRow,
    setSelectedRow,
} from "../../actions/Builder.js";
import Spin2Win from "../../components/Spin2Win.js";
import Switch from "rc-switch";

import Nav from "./Nav";
import DroppableElement from "../../components/builder/DroppableElement.js";
import DraggableElement from "../../components/builder/DraggableElement.js";
import Row from "../../components/builder/Row.js";
import SidebarTabButton from "../../components/builder/SidebarTabButton.js";
import ItemTypes from "../../ItemTypes.js";

import SidebarRowElement from "../../components/builder/SidebarRowElement.js";
import SidebarPageElement from "../../components/builder/SidebarPageElement.js";
import Preview from "../../components/builder/Preview.js";

import TextObj from "../../helpers/text.js";
import UploadObj from "../../helpers/upload.js";
import RowObj from "../../helpers/row.js";
import SpacingObj from "../../helpers/spacing.js";
import PageObj from "../../helpers/page.js";
import CartObj from "../../helpers/cart.js";

import ElementObj from "../../helpers/element.js";
import { getItemObject, getItemComponent } from "../../helpers/functions.js";

import Portal from "react-portal";
import FullScreenOverlay from "../../components/FullScreenOverlay.js";

import RuleSelector from "../../components/builder/RuleSelector.js";
import RuleSendAfter from "../../components/builder/RuleSendAfter.js";
import RuleListenForEvent from "../../components/builder/RuleListenForEvent.js";
import RuleOrderSum from "../../components/builder/RuleOrderSum.js";
import RuleCartSum from "../../components/builder/RuleCartSum.js";
import General from "../../modules/General";
import RuleFollowUpEvent from "../../components/builder/RuleFollowUpEvent.js";
import RuleSendToSegmentEvent from "../../components/builder/RuleSendToSegmentEvent.js";
import RuleSendOnTrigger from "../../components/builder/RuleSendOnTrigger.js";
import RulePicker from "../../components/builder/RulePicker.js";
import DiscountPicker from "../../components/builder/DiscountPicker";
import UpgradeRequired from "../../components/UpgradeRequired";
import StopOn from "../../components/builder/StopOn";
import EmailListPicker from "../../components/EmailListPicker";
import DateTimePicker from "../../components/widgets/DateTimePicker";
import moment from "moment/moment";

const components = {
    RuleSendToSegmentEvent: RuleSendToSegmentEvent,
    RuleSendAfter: RuleSendAfter,
    RuleListenForEvent: RuleListenForEvent,
    RuleOrderSum: RuleOrderSum,
    RuleFollowUpEvent: RuleFollowUpEvent,
    RuleSendOnTrigger: RuleSendOnTrigger,
    RuleCartSum: RuleCartSum,
};

function byIndex(a, b) {
    if (a.sorting < b.sorting) return -1;
    if (a.sorting > b.sorting) return 1;
    return 0;
}

class Email extends React.Component {
    constructor(props) {
        super(props);
        this.renderRows = this.renderRows.bind(this);
        this.setSelectedTab = this.setSelectedTab.bind(this);
        this.moveRow = this.moveRow.bind(this);
        this.setSelectedRow = this.setSelectedRow.bind(this);
        this.removeElement = this.removeElement.bind(this);
        this.addRowPlaceholder = this.addRowPlaceholder.bind(this);
        this.addRow = this.addRow.bind(this);
        this.renderSidebarElement = this.renderSidebarElement.bind(this);
        this.renderSidebarRow = this.renderSidebarRow.bind(this);
        this.renderTab = this.renderTab.bind(this);
        this.renderBuilder = this.renderBuilder.bind(this);
        this.renderLoading = this.renderLoading.bind(this);
        this.save = this.save.bind(this);
        this.buildSaveableObject = this.buildSaveableObject.bind(this);
        this.get = this.get.bind(this);
        this.rebuildSave = this.rebuildSave.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleSubjectChange = this.handleSubjectChange.bind(this);
        this.update = this.update.bind(this);
        this.displayPreview = this.displayPreview.bind(this);
        this.overview = this.overview.bind(this);
        this.renderStopOn = this.renderStopOn.bind(this);
        this.state = {
            isLoading: true,
            previewOpen: false,
            isAddingRule: true,
            showOverview: false,
            isAddingDiscount: false,
            isLoadingNewsletterLists: true,
        };

        this.addRule = this.addRule.bind(this);

        contextTypes: {
            router: React.PropTypes.object.isRequired;
        }
    }

    renderStopOn(rule) {
        return (
            <div
                className="rules m-t-40 text-center col-sm-12"
                key="stop-follow-up"
            >
                <div className="m-b-20 strike">
                    <span>Stop followup</span>
                </div>
                <div className="col-sm-10 text-center offset-sm-1 p-0">
                    <p>
                        Don't send this e-mail and stop followup chain on this
                        events
                    </p>
                    <div className="col-sm-12 bg-grey-100 text-left list-group bg-inherit">
                        <StopOn
                            save={(value) =>
                                this.props.setGlobalKeyState("stop_on", value)
                            }
                            data={this.props.builder.stop_on}
                        />
                    </div>
                </div>
            </div>
        );
    }

    addRule(rule) {
        this.props.setGlobalTypeState("rules", rule.id, rule);
        this.setState({ isAddingRule: false });
    }

    handleSubjectChange(e) {
        this.props.setGlobalTypeState("page", false, {
            subject: e.target.value,
        });
    }

    handleStatusChange(value) {
        let val = value == true ? 1 : 0;
        this.props.setGlobalKeyState("status", val);
    }

    overview(e) {
        e.stopPropagation();
        this.setState({ showOverview: true });
    }

    isUsingFlows() {
        return this.props.general.settings.FLOW == "1" ? true : false;
    }

    displayPreview() {
        this.setState({ previewOpen: !this.state.previewOpen });
    }

    addRow(row) {
        this.props.addRow(row);
    }

    handleRuleKeyChange(index, key, value) {
        this.props.changeRule(index, key, value);
    }

    buildSaveableObject() {
        return {
            stop_on: this.props.builder.stop_on,
            rules: this.props.builder.rules,
            status: this.props.builder.status,
            subject: this.props.builder.page.subject,
            tags: this.buildableTags(),
            data: stringify(this.props.builder),
        };
    }

    buildableTags = () => {
        let tags = {
            ...this.props.builder.tags,
        };

        if (Object.keys(tags).length == 0) {
            return [];
        }

        if (tags.SendType === "immediately") {
            tags.SendAt = 0;
        } else {
            tags.SendAt = moment(tags.SendAt)
                .add(-moment().utcOffset(), "m")
                .format("YYYY-MM-DD HH:mm:ss");
        }

        return tags;
    };

    rebuildSave(save) {
        let data = JSON.parse(save.data);

        let page = new PageObj(data.page);

        page.item.type = save.type;
        page.item.subject = save.subject;

        this.props.setGlobalTypeState("sidebar", false, {
            selectedTab: "components",
            visible: false,
            selectedElement: false,
            selectedRow: false,
            selectedSetting: false,
        });

        let stop_on = save.stop_on;
        if (stop_on == "" || !stop_on) {
            stop_on = "";
        }

        this.props.setGlobalTypeState("page", false, page.output());
        this.props.setGlobalKeyState("stop_on", stop_on);
        this.props.setGlobalKeyState("status", save.status);
        this.props.setGlobalKeyState("isAbTesting", save.isAbTesting);
        this.props.setGlobalKeyState("rows", {});
        this.props.setGlobalKeyState("elements", {});
        this.props.setGlobalKeyState("components", {});
        this.props.setGlobalKeyState("rules", {});
        this.props.setGlobalKeyState("tags", {});

        if (save.tags) {
            Object.keys(save.tags).map((key) => {
                if (key == "SendAt") {
                    if (save.tags[key] == "0") {
                        save.tags[key] = moment(moment().add(7, "days"));
                    } else {
                        save.tags[key] = moment
                            .utc(save.tags[key], "YYYY-MM-DD HH:mm:ss")
                            .local();
                    }
                }
            });

            this.props.setGlobalKeyState("tags", save.tags);
        }

        Object.keys(data.rows).map((key) => {
            let row = new RowObj(data.rows[key]);
            this.props.setGlobalTypeState("rows", row.item.id, row.output());
        });

        let components = {};

        Object.keys(data.elements).map((key) => {
            let element = new ElementObj(data.elements[key]);
            components[element.item.id] = element.item.type;
            this.props.setGlobalTypeState(
                "elements",
                element.item.id,
                element.output()
            );
        });

        Object.keys(data.components).map((key) => {
            let component = getItemObject(
                components[key],
                data.components[key]
            );
            this.props.setGlobalTypeState(
                "components",
                component.item.id,
                component.output()
            );
        });

        if (save.rules.length > 0) {
            save.rules.map((rule) => {
                this.props.setGlobalTypeState("rules", rule.id, rule);
            });
        }

        this.setState({ isLoading: false });
    }

    get(id) {
        axios
            .get("/emails/" + id)
            .then((response) => {
                this.rebuildSave(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    update(options = {}) {
        this.setState({ showOverview: false });

        let saveObject = this.buildSaveableObject();

        if (options.completed == 1) {
            saveObject.completed = 1;
        }

        axios
            .put("/emails/" + this.props.params.email_id, saveObject)
            .then((response) => {
                Notification.success("E-mail saved");
                if (options.redirect) {
                    if (this.isUsingFlows()) {
                        window.location = this.getRedirectLink();
                    } else {
                        this.props.router.push(this.backLink());
                    }
                }
            })
            .catch((error) => {
                console.dir(error);
                Notification.error(error.message);
            });
    }

    save(e, redirect = true) {
        if (e) {
            e.stopPropagation();
        }

        this.postSave({
            redirect: redirect,
        });
    }

    postSave = (options = {}) => {
        if (this.props.builder.page.subject == "") {
            Notification.error("E-mail subject can't be empty");
            return;
        }

        Notification.info("Saving...");

        if (typeof this.props.params.email_id !== "undefined") {
            this.update(options);
            return;
        }

        let saveObject = this.buildSaveableObject();

        if (options.completed == 1) {
            saveObject.completed = 1;
        }

        axios
            .post("/emails", saveObject)
            .then((response) => {
                Notification.success("E-mail saved");
            })
            .catch((error) => {
                console.dir(error);
                Notification.error(error.message);
            });
    };

    renderRow(row) {
        let columns = [];
        const maxCols = parseInt(row.columns) - 1;

        for (let i = 0; i <= maxCols; i++) {
            let elements = [];

            for (let i2 in this.props.c.elements) {
                let el = this.props.c.elements[i2];
                if (row.index == el.rowId && el.colId == i) {
                    elements.push(el);
                }
            }

            elements.sort(byIndex);

            columns.push(
                <DropTd
                    row={row}
                    move={this.move}
                    colId={i}
                    elements={elements}
                    addElement={this.props.addElement}
                />
            );
        }

        return (
            <table className="">
                <tr>{columns}</tr>
            </table>
        );
    }

    moveRow(newPosition, newSorting) {
        this.props.moveRow(newPosition, newSorting);
    }

    addRowPlaceholder(newPosition, newSorting) {
        newPosition.id = uuidV4();
        newPosition.type = "placeholder";
        this.props.addRowPlaceholder(newPosition, newSorting);
        return newPosition;
    }

    setSelectedRow(id) {
        if (id != this.props.builder.sidebar.selectedRow) {
            this.props.setSelectedRow(id);
        }
    }

    removeElement(el) {
        if (el.type == "row") {
            this.props.deleteRow(el.id);
        } else {
            this.props.removeElement(el);
        }
    }

    renderRows() {
        let ret = [];
        let sortableRow = [];
        let sortedElements = {};
        let rows = [];

        for (let i in this.props.builder.rows) {
            let r = this.props.builder.rows[i];
            let elements = [];
            if (r.elements.length > 0) {
                r.elements.map((el) => {
                    elements.push(this.props.builder.elements[el]);
                });
                elements.sort(byIndex);
            }
            sortedElements[r.id] = elements;
            sortableRow.push(r);
        }

        sortableRow.map((r) => {
            rows.push(r);
        });

        sortableRow.sort(byIndex);
        sortableRow.map((r) => {
            if (r.type == "placeholder") {
                ret.push(
                    <Row
                        isSelected={
                            this.props.builder.sidebar.selectedRow == r.id
                                ? true
                                : false
                        }
                        key={r.id}
                        setSelectedRow={this.setSelectedRow}
                        addRowPlaceholder={this.addRowPlaceholder}
                        addRow={this.addRow}
                        deleteRow={this.deleteRow}
                        moveRow={this.moveRow}
                        rows={rows}
                        row={r}
                        elements={sortedElements[r.id]}
                    />
                );
            } else {
                ret.push(
                    <Row
                        isSelected={
                            this.props.builder.sidebar.selectedRow == r.id
                                ? true
                                : false
                        }
                        key={r.id}
                        deleteRow={this.deleteRow}
                        setSelectedRow={this.setSelectedRow}
                        addRowPlaceholder={this.addRowPlaceholder}
                        moveRow={this.moveRow}
                        addRow={this.addRow}
                        rows={rows}
                        row={r}
                        elements={sortedElements[r.id]}
                    />
                );
            }
        });
        return ret;
    }

    setSelectedTab(tab) {
        this.props.setSelectedTab(tab);
    }

    renderLayout() {
        return (
            <div className="p-l-15 component-wrapper m-t-20">
                <DraggableElement
                    removeElement={this.removeElement}
                    text="One column"
                    type="row"
                    settings={{ columns: 1 }}
                    dragType={ItemTypes.NEW_ROW}
                    image="/images/svg/1col.svg"
                />
                <DraggableElement
                    removeElement={this.removeElement}
                    text="Two columns"
                    type="row"
                    settings={{ columns: 2 }}
                    dragType={ItemTypes.NEW_ROW}
                    image="/images/svg/2col.svg"
                />
                <DraggableElement
                    removeElement={this.removeElement}
                    text="Three columns"
                    type="row"
                    settings={{ columns: 3 }}
                    dragType={ItemTypes.NEW_ROW}
                    image="/images/svg/3col.svg"
                />
                <DraggableElement
                    removeElement={this.removeElement}
                    text="Header"
                    type="header"
                    settings={{}}
                    dragType={ItemTypes.NEW_ELEMENT}
                    image={"/images/svg/header.svg"}
                />
                <DraggableElement
                    removeElement={this.removeElement}
                    text="Footer"
                    type="footer"
                    settings={{}}
                    dragType={ItemTypes.NEW_ELEMENT}
                    image={"/images/svg/footer.svg"}
                />
            </div>
        );
    }

    renderComponents() {
        return (
            <div className="p-l-15 component-wrapper m-t-20">
                <DraggableElement
                    removeElement={this.removeElement}
                    text="Text"
                    type="text"
                    settings={{}}
                    dragType={ItemTypes.NEW_ELEMENT}
                    image={"/images/svg/text.svg"}
                />
                <DraggableElement
                    removeElement={this.removeElement}
                    text="Image"
                    type="upload"
                    settings={{}}
                    dragType={ItemTypes.NEW_ELEMENT}
                    image={"/images/svg/image.svg"}
                />
                <DraggableElement
                    removeElement={this.removeElement}
                    text="Button"
                    type="button"
                    settings={{}}
                    dragType={ItemTypes.NEW_ELEMENT}
                    image={"/images/svg/button.svg"}
                />
                <DraggableElement
                    removeElement={this.removeElement}
                    text="Spacing"
                    type="spacing"
                    settings={{}}
                    dragType={ItemTypes.NEW_ELEMENT}
                    image={"/images/svg/spacing.svg"}
                />
                <DraggableElement
                    removeElement={this.removeElement}
                    text="Divider"
                    type="divider"
                    settings={{}}
                    dragType={ItemTypes.NEW_ELEMENT}
                    image={"/images/svg/divider.svg"}
                />
                <DraggableElement
                    removeElement={this.removeElement}
                    text="Social follow"
                    type="socialfollow"
                    settings={{}}
                    dragType={ItemTypes.NEW_ELEMENT}
                    image={"/images/svg/social.svg"}
                />
                <DraggableElement
                    removeElement={this.removeElement}
                    text="Discount"
                    type="discount"
                    settings={{}}
                    dragType={ItemTypes.NEW_ELEMENT}
                    image={"/images/svg/discount.svg"}
                />
                <DraggableElement
                    removeElement={this.removeElement}
                    text="List"
                    type="list"
                    settings={{}}
                    dragType={ItemTypes.NEW_ELEMENT}
                    image={"/images/svg/list.svg"}
                />
                <DraggableElement
                    removeElement={this.removeElement}
                    text="Custom Html"
                    type="customhtml"
                    settings={{}}
                    dragType={ItemTypes.NEW_ELEMENT}
                    image={"/images/svg/coding.svg"}
                />

                <DraggableElement
                    key="recommendation"
                    removeElement={this.removeElement}
                    text="Recommendation"
                    type="crallrecommendationdynamo"
                    settings={{}}
                    dragType={ItemTypes.NEW_ELEMENT}
                    image={"/images/svg/recommendation.svg"}
                />

                {this.props.builder.page.type == "ORDER_CONFIRMATION" ? (
                    <DraggableElement
                        key="orderdetails"
                        removeElement={this.removeElement}
                        text="Order details"
                        type="ordersummary"
                        settings={{}}
                        dragType={ItemTypes.NEW_ELEMENT}
                        image={"/images/svg/orderdetails.svg"}
                    />
                ) : null}
                {this.props.builder.page.type == "ORDER_CONFIRMATION" ? (
                    <DraggableElement
                        key="recheckout"
                        removeElement={this.removeElement}
                        text="Recheckout"
                        type="recheckout"
                        settings={{}}
                        dragType={ItemTypes.NEW_ELEMENT}
                        image={"/images/svg/refresh.svg"}
                    />
                ) : null}
                {this.props.builder.page.type == "CART_REMINDER" ? (
                    <DraggableElement
                        removeElement={this.removeElement}
                        text="Abandoned cart"
                        type="cart"
                        settings={{}}
                        dragType={ItemTypes.NEW_ELEMENT}
                        image={"/images/svg/cart2.svg"}
                    />
                ) : null}

                {this.props.builder.page.type == "SEGMENT" ||
                this.props.builder.page.type == "NEWSLETTER" ||
                this.props.builder.page.type == "TRIGGER" ? (
                    <DraggableElement
                        removeElement={this.removeElement}
                        text="Product selection"
                        type="productselection"
                        settings={{}}
                        dragType={ItemTypes.NEW_ELEMENT}
                        image={"/images/svg/cart2.svg"}
                    />
                ) : null}
                {this.props.builder.page.type == "BASIC" ||
                this.props.builder.page.type == "TRIGGER" ? (
                    <DraggableElement
                        removeElement={this.removeElement}
                        text="Shipping tracker"
                        type="shippingtracker"
                        settings={{}}
                        dragType={ItemTypes.NEW_ELEMENT}
                        image={"/images/svg/package.svg"}
                    />
                ) : null}
            </div>
        );
    }

    renderDraggable() {
        return (
            <div className="slide-in">
                <div
                    className="btn-group col-sm-12  m-t-20"
                    aria-label="Default button group"
                    role="group"
                >
                    <SidebarTabButton
                        setSelectedTab={this.setSelectedTab}
                        selectedTab={this.props.builder.sidebar.selectedTab}
                        tab="components"
                        text="Components"
                    />
                    <SidebarTabButton
                        setSelectedTab={this.setSelectedTab}
                        selectedTab={this.props.builder.sidebar.selectedTab}
                        tab="layout"
                        text="Rows"
                    />
                    <SidebarTabButton
                        setSelectedTab={this.setSelectedTab}
                        selectedTab={this.props.builder.sidebar.selectedTab}
                        tab="settings"
                        text="Settings"
                    />
                </div>

                <div className="clearfix"></div>
                {this.renderTab()}
                <div className="clearfix"></div>
            </div>
        );
    }

    renderRule(rule) {
        const Comp = components["Rule" + rule.key];
        return (
            <Comp
                setGlobalTypeState={this.props.setGlobalTypeState}
                rule={rule}
                key={rule.id}
            />
        );
    }

    renderTab() {
        switch (this.props.builder.sidebar.selectedTab) {
            case "components":
                return this.renderComponents();
                break;

            case "settings":
                return this.renderSidebarPage();
                break;

            default:
                return this.renderLayout();
                break;
        }
    }

    renderSidebarElement() {
        return getItemComponent(
            this.props.builder.elements[
                this.props.builder.sidebar.selectedElement
            ],
            1,
            true
        );
    }

    renderSidebarRow() {
        return (
            <SidebarRowElement
                setGlobalTypeState={this.props.setGlobalTypeState}
                setSidebarState={this.props.setSidebarState}
                row={
                    this.props.builder.rows[
                        this.props.builder.sidebar.selectedRow
                    ]
                }
            />
        );
    }

    renderSidebarPage() {
        return (
            <SidebarPageElement
                isUsingFlow={this.isUsingFlows()}
                components={components}
                subject={this.props.builder.page.subject}
                rules={this.props.builder.rules}
                selectedSetting={this.props.builder.sidebar.selectedSetting}
                setGlobalTypeState={this.props.setGlobalTypeState}
                page={this.props.builder.page}
                setSidebarState={this.props.setSidebarState}
            />
        );
    }

    renderSidebar() {
        if (this.state.isLoading) {
            return false;
        }
        switch (this.props.builder.sidebar.visible) {
            case "element":
                return this.renderSidebarElement();
                break;

            case "row":
                return this.renderSidebarRow();
                break;

            default:
                return this.renderDraggable();
                break;
        }
    }

    renderBuilder() {
        if (this.state.isLoading) {
            return;
        }

        if (Object.keys(this.props.builder.page).length == 0) {
            return;
        }

        let page_style = {};
        page_style.fontFamily = this.props.builder.page.font;
        page_style.fontSize = this.props.builder.page.fontSize;
        page_style.color = this.props.builder.page.color;
        page_style.backgroundColor = this.props.builder.page.backgroundColor;
        page_style.borderTop = this.props.builder.page.borderTop.replace(
            /\|/g,
            " "
        );
        page_style.borderBottom = this.props.builder.page.borderBottom.replace(
            /\|/g,
            " "
        );

        return (
            <table
                id="builder-page"
                className="parent-table"
                style={page_style}
            >
                <tbody>
                    <tr>
                        <DroppableElement
                            acceptDropType={ItemTypes.ROW}
                            classes="valign-top"
                            type="td"
                        >
                            {this.renderRows()}
                        </DroppableElement>
                    </tr>
                </tbody>
            </table>
        );
    }

    renderLoading() {
        if (!this.state.isLoading) {
            return;
        }

        return (
            <div className="loading">
                <Spin2Win />
            </div>
        );
    }

    componentDidMount() {
        if (typeof this.props.params.email_id !== "undefined") {
            this.get(this.props.params.email_id);
        } else {
            let page = new PageObj(false);
            this.props.setGlobalTypeState("page", false, page.output());

            this.setState({ isLoading: false });
        }
    }

    handleSchedulerChange = (e) => {
        this.props.setTag("SendType", e.target.value);
    };

    handleScheduleDateChange = (date) => {
        this.props.setTag("SendAt", date);
    };

    getRedirectLink = () => {
        if (!this.props.params.type) {
            return this.backLink();
        }

        if (this.props.params.type == "emails") {
            return General.Link2("/emails/templates");
        }

        let split = this.props.params.type.split("-");

        if (split.length != 2) {
            return this.backLink();
        }

        if (split[0] == "f") {
            return General.Link2("/flows/builder/" + split[1]);
        }

        return this.backLink();
    };

    backLink = () => {
        let link = General.Link("/emails");

        if (this.isUsingFlows()) {
            link = General.Link2("/emails/campaigns");
        }

        if (this.props.builder.page.type == "NEWSLETTER") {
            link = General.Link("/newsletters");
        }

        return link;
    };

    handleListLoadingChange = (value) => {
        this.setState({
            isLoadingNewsletterLists: value,
        });
    };

    seveNewsletter = () => {
        this.save();
    };

    sendNewsletter = () => {
        let hasList = false;
        Object.keys(this.props.builder.rules).map((i) => {
            if (
                this.props.builder.rules[i].key == "SendToList" &&
                this.props.builder.rules[i].value != ""
            ) {
                hasList = true;
            }
        });

        if (!hasList) {
            Notification.error("You must select a recipient list");
            return;
        }

        this.postSave({
            completed: 1,
            redirect: true,
        });
    };

    //this.renderSidebar()
    render() {
        return (
            <div className="height-100">
                <Nav
                    backLink={this.getRedirectLink()}
                    backText="Back to emails"
                >
                    <li className="nav-item hidden-float">
                        <a
                            className="nav-link"
                            href="javascript:void(0)"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.displayPreview();
                            }}
                        >
                            Preview / Test
                        </a>
                    </li>
                    <li className="nav-item hidden-float">
                        <a
                            className="nav-link"
                            href="javascript:void(0)"
                            onClick={(e) => this.save(e, false)}
                        >
                            Quick save
                        </a>
                    </li>
                    <li className="nav-item hidden-float save-and-continue">
                        <a
                            className="nav-link "
                            href="javascript:void(0)"
                            onClick={(e) => this.overview(e)}
                        >
                            Save and continue{" "}
                            <i
                                className="fa fa-chevron-right"
                                style={{ fontSize: "12px" }}
                                aria-hidden="true"
                            ></i>
                        </a>
                    </li>
                </Nav>

                {this.renderLoading()}

                <div className="height-100">
                    <div className="sidebar height-100 col-sm-4 p-0">
                        {this.renderSidebar()}
                    </div>

                    <div className="main-content col-sm-8 p-0 height-100">
                        {this.renderBuilder()}
                    </div>
                </div>

                {!this.state.isLoading &&
                this.props.builder.page.type == "NEWSLETTER" ? (
                    <Portal
                        closeOnEsc
                        onClose={(e) => {
                            this.setState({ showOverview: false });
                        }}
                        isOpened={this.state.showOverview}
                    >
                        <FullScreenOverlay>
                            <div className="overview m-t-30 col-sm-6 offset-sm-3 text-center">
                                <h1>Almost ready to launch!</h1>
                                <h2>
                                    Please take your time and look over the
                                    settings for this e-mail.
                                </h2>

                                <div className="m-t-40 col-sm-12">
                                    <div className="m-b-20 strike">
                                        <span>E-mail subject</span>
                                    </div>
                                    <div className="col-sm-10 offset-sm-1">
                                        <input
                                            type="text"
                                            onChange={this.handleSubjectChange}
                                            className="form-control form-control-lg"
                                            value={
                                                this.props.builder.page.subject
                                            }
                                            placeholder="My awesome e-mail"
                                        />
                                    </div>
                                </div>

                                <div className="rules m-t-40 col-sm-12">
                                    <div className="m-b-20 strike">
                                        <span>Send to</span>
                                    </div>
                                    <div className="col-sm-10 offset-sm-1 text-left p-0">
                                        <EmailListPicker
                                            handleChangeList={(e) => {
                                                this.props.setTag(
                                                    "SendToList",
                                                    e
                                                );
                                            }}
                                            handleLoadingChange={
                                                this.handleListLoadingChange
                                            }
                                            listId={parseInt(
                                                this.props.builder.tags
                                                    .SendToList
                                            )}
                                        />
                                    </div>
                                </div>

                                <div className="rules m-t-40 col-sm-12">
                                    <div className="m-b-20 strike">
                                        <span>
                                            When do you want to send your
                                            newsletter?
                                        </span>
                                    </div>
                                    <div className="col-sm-10 offset-sm-1 text-left p-0">
                                        <div className="form-group row">
                                            <label className="col-md-3 col-form-label">
                                                <div className="radio-custom radio-primary">
                                                    <input
                                                        type="radio"
                                                        value="immediately"
                                                        onChange={
                                                            this
                                                                .handleSchedulerChange
                                                        }
                                                        checked={
                                                            this.props.builder
                                                                .tags
                                                                .SendType ===
                                                            "immediately"
                                                        }
                                                    />
                                                    <label>Immediately</label>
                                                </div>
                                            </label>
                                            <div className="col-md-9"></div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="col-md-3 col-form-label">
                                                <div className="radio-custom radio-primary">
                                                    <input
                                                        type="radio"
                                                        value="send_at"
                                                        onChange={
                                                            this
                                                                .handleSchedulerChange
                                                        }
                                                        checked={
                                                            this.props.builder
                                                                .tags
                                                                .SendType !==
                                                            "immediately"
                                                        }
                                                    />
                                                    <label>Sent at</label>
                                                </div>
                                            </label>
                                            <div className="col-md-9">
                                                <DateTimePicker
                                                    isChecked={
                                                        this.props.builder.tags
                                                            .SendType !==
                                                        "immediately"
                                                    }
                                                    handleDateChange={
                                                        this
                                                            .handleScheduleDateChange
                                                    }
                                                    date={
                                                        this.props.builder.tags
                                                            .SendAt
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-10 offset-sm-1 m-t-50 m-b-50">
                                    <div className="col-sm-12">
                                        <button
                                            type="button"
                                            onClick={this.sendNewsletter}
                                            className="btn p-l-40 p-r-40 btn-dark btn-lg"
                                            disabled={
                                                this.state
                                                    .isLoadingNewsletterLists
                                            }
                                        >
                                            <i
                                                className="icon fa-send"
                                                aria-hidden="true"
                                            ></i>
                                            {this.props.builder.tags
                                                .SendType === "send_at"
                                                ? "Schedule e-mail"
                                                : "Send now"}
                                        </button>
                                        <br />
                                        <br />
                                        <button
                                            type="button"
                                            onClick={this.seveNewsletter}
                                            className="btn btn-outline btn-dark"
                                            disabled={
                                                this.state
                                                    .isLoadingNewsletterLists
                                            }
                                        >
                                            <i
                                                className="icon fa-save"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            I'll finish this later
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </FullScreenOverlay>
                    </Portal>
                ) : null}

                {!this.state.isLoading &&
                this.props.builder.page.type != "NEWSLETTER" ? (
                    <Portal
                        closeOnEsc
                        onClose={(e) => {
                            this.setState({ showOverview: false });
                        }}
                        isOpened={this.state.showOverview}
                    >
                        <FullScreenOverlay>
                            <div className="overview m-t-30 col-sm-6 offset-sm-3 text-center">
                                <h1>Almost done!</h1>
                                <h2>
                                    Please take your time and look over the
                                    settings for this e-mail.
                                </h2>

                                <div className="m-t-40 col-sm-12">
                                    <div className="m-b-20 strike">
                                        {this.props.builder.page.type !=
                                        "TEMPLATE" ? (
                                            <span>
                                                E-mail subject ( Will be visible
                                                for the customer )
                                            </span>
                                        ) : (
                                            <span>Template name</span>
                                        )}
                                    </div>
                                    <div className="col-sm-10 offset-sm-1">
                                        <input
                                            type="text"
                                            onChange={this.handleSubjectChange}
                                            className="form-control form-control-lg"
                                            value={
                                                this.props.builder.page.subject
                                            }
                                            placeholder="My awesome e-mail"
                                        />
                                    </div>
                                </div>
                                {Object.keys(this.props.builder.rules).filter(
                                    (i) => {
                                        return this.props.builder.rules[i]
                                            .action == "Who" &&
                                            this.props.builder.page.type !=
                                                "TEMPLATE" &&
                                            !this.isUsingFlows()
                                            ? true
                                            : false;
                                    }
                                ).length > 0 ? (
                                    <div className="rules m-t-40 col-sm-12">
                                        <div className="m-b-20 strike">
                                            <span>Who</span>
                                        </div>
                                        <div className="col-sm-10 bg-grey-100 text-left offset-sm-1 list-group bg-inherit">
                                            {Object.keys(
                                                this.props.builder.rules
                                            ).map((i) => {
                                                return this.props.builder.rules[
                                                    i
                                                ].action == "Who"
                                                    ? this.renderRule(
                                                          this.props.builder
                                                              .rules[i]
                                                      )
                                                    : null;
                                            })}
                                        </div>
                                    </div>
                                ) : null}

                                {Object.keys(this.props.builder.rules).filter(
                                    (i) => {
                                        return this.props.builder.rules[i]
                                            .action == "When" &&
                                            this.props.builder.page.type !=
                                                "TEMPLATE" &&
                                            !this.isUsingFlows()
                                            ? true
                                            : false;
                                    }
                                ).length > 0 ? (
                                    <div className="rules m-t-40 col-sm-12">
                                        <div className="m-b-20 strike">
                                            <span>When</span>
                                        </div>
                                        <div className="col-sm-10 bg-grey-100 text-left offset-sm-1 list-group bg-inherit">
                                            {Object.keys(
                                                this.props.builder.rules
                                            ).map((i) => {
                                                return this.props.builder.rules[
                                                    i
                                                ].action == "When"
                                                    ? this.renderRule(
                                                          this.props.builder
                                                              .rules[i]
                                                      )
                                                    : null;
                                            })}
                                        </div>
                                    </div>
                                ) : null}

                                {Object.keys(this.props.builder.rules).map(
                                    (i) => {
                                        return this.props.builder.rules[i]
                                            .key == "FollowUpEvent"
                                            ? this.renderStopOn(
                                                  this.props.builder.rules[i]
                                              )
                                            : null;
                                    }
                                )}

                                {this.props.builder.page.type != "TEMPLATE" &&
                                !this.isUsingFlows() ? (
                                    <div className="m-t-40 col-sm-12">
                                        <div className="m-b-20 strike">
                                            <span>E-mail status</span>
                                        </div>
                                        {this.props.general.settings
                                            .PACKAGE_EMAIL == "1" ? (
                                            <div className="col-sm-10 offset-sm-1">
                                                {this.props.builder
                                                    .isAbTesting ? (
                                                    <div
                                                        className="alert alert-icon alert-warning alert-dismissible"
                                                        role="alert"
                                                    >
                                                        <i
                                                            className="icon wb-bell"
                                                            aria-hidden="true"
                                                        ></i>{" "}
                                                        This e-mail is part of
                                                        an A/B test. You must
                                                        disable the A/B before
                                                        you can enable/disable
                                                        this e-mail.
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <div className="col-sm-4 text-right">
                                                            Activate e-mail
                                                        </div>

                                                        <div className="col-sm-6 text-right">
                                                            <Switch
                                                                onChange={
                                                                    this
                                                                        .handleStatusChange
                                                                }
                                                                checked={
                                                                    this.props
                                                                        .builder
                                                                        .status ==
                                                                    1
                                                                        ? true
                                                                        : false
                                                                }
                                                                checkedChildren={
                                                                    <i className="icon fa-check"></i>
                                                                }
                                                                unCheckedChildren={
                                                                    <i className="icon fa-close"></i>
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="col-sm-10 offset-sm-1">
                                                <UpgradeRequired message="If you want to enable e-mails, you need to upgrade your account to a larger package" />
                                            </div>
                                        )}
                                    </div>
                                ) : null}

                                <div className="col-sm-10 offset-sm-1">
                                    <button
                                        type="button"
                                        onClick={this.save}
                                        className="btn p-l-40 p-r-40 btn-dark btn-lg m-t-50 m-b-50"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </FullScreenOverlay>
                    </Portal>
                ) : null}

                {this.state.previewOpen ? (
                    <Preview
                        id={this.props.router.params.email_id}
                        auth={this.props.auth}
                        displayPreview={this.displayPreview}
                    />
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        builder: state.builder,
        general: state.general,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            setTag,
            changeRule,
            setGlobalKeyState,
            deleteRow,
            setGlobalTypeState,
            setSidebarState,
            addRow,
            addRowPlaceholder,
            removeElement,
            setSelectedTab,
            setSelectedRow,
            moveRow,
        },
        dispatch
    );
};

Email = DragDropContext(HTML5Backend)(Email);
Email = connect(mapStateToProps, mapDispatchToProps)(Email);
export default Email;



// WEBPACK FOOTER //
// ./containers/builder/email.js